import { Button, Divider, Picker, Space } from "antd-mobile";
import React, { useState } from "react";

export default function Stores(props) {


    const {
        logout = () => { },
        session = {},
        continueToBMO = () => { }
    } = props;

    const corps = session?.available_corps || [];

    const [selected, setSelected] = useState(corps.find(item => item.id === session.corp_id));
    const [visible, setVisible] = useState(false);

    const drawPicker = () => {


        const options = corps.filter(item => item.can_bmo).map(item => {
            return ({
                label: item.name,
                value: item.id
            })
        })
        return (
            <div>
                <Button block onClick={() => setVisible(true)}>{selected?.name}&nbsp;</Button>
                <Picker
                    columns={[options]}
                    visible={visible}
                    onClose={() => setVisible(false)}
                    onConfirm={(item, e) => {
                        let _f = options.find(a => a.value == item);
                        if (_f) {
                            setSelected({ id: _f.value, name: _f.label })
                        }
                        setVisible(false);
                    }}
                    confirmText={"Select"} // Hides the confirm button
                    cancelText={"Cancel"}  // Hides the cancel button
                />
            </div>
        )
    }


    return (
        <>
            <div>
                <big><span style={{ "opacity": "0.5" }}>Choose a store</span></big><br /><br />
                <div style={{ "padding": "0px 20px" }}>
                    <div style={{ "textAlign": "left", "padding": "5px 15px", "opacity": "0.5" }}>Stores:</div>
                </div>
                <div style={{ "padding": "30px", "paddingTop": "20px", "overflow": "auto", "height": "calc(100vh - 320px)" }}>
                    <div>
                        <Space block direction="vertical">
                            {corps.filter(item => item.can_bmo).map((item) => {
                                return (<Button key={item?.id} style={{ "backgroundColor": "#ffffff11" }} onClick={() => continueToBMO(item?.id, item)} color={"default"} block>{item.name}</Button>)
                            })}
                        </Space>
                    </div>
                </div>
                <div style={{ "padding": "0px 30px" }}>
                    <Divider><a onClick={() => logout()}>Logout</a></Divider>
                </div>
            </div>
        </>
    )
}